import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as endpoints from "../../api/endpoints"
import { isMobile } from "react-device-detect"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import Svg from "../_svgs/svg"
import SearchOverlay from "../flight-search-hero/search-overlay"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import * as cookieHelper from "../../helpers/cookie"
import { DateTime } from "luxon"

export default class FlightSearchComponent extends Component {
  constructor(props) {
    super(props)

    const formatString = "yyyy-MM-dd HH:mm"
    const dtLocale = dateHelper.luxonLocale(props.locale)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.fromFormat(this.props.datetime, formatString).setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })

    this.state = {
      flights: [],
      direction: props.direction || "D",
      q: "",
      showOverlay: false,
      searchDate: startDate,
      minDate: minDate,
      datepickerOpen: false,
      minTime: minTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      mobileInputFocus: false,
      startDate: startDate,
    }
  }

  componentDidMount() {
    this.addEventListeners()
  }

  addEventListeners() {
    document.body.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.setState({ showOverlay: false })
        if (isMobile) {
          this.scrollIntoView()
          this.props.handleOverlay(false)
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = null
            let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
            if (siteHeaderWrapper) {
              siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
            }
          }
          this.setZIndexOfNotificationBanner(null)
        }
        const input = document.querySelector("#flight-search-hero-input")
        if (input) {
          input.blur()
        }
      }
    })
  }

  search = async () => {
    if (this.state.q.length >= (this.props.minCharsBeforeSearch ?? 2)) {
      const dt = this.state.searchDate
      const zone = "Europe/Copenhagen"
      const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
      const start = cphTime.toUTC() // convert to UTC which is what Solr expects
      const end = cphTime.endOf("day").toUTC() // convert to UTC which is what Solr expects
      const flightsData = {
        direction: this.state.direction,
        query: this.state.q,
        startDateTime: start,
        endDateTime: end,
        language: this.props.locale,
      }

      const returns = await Promise.all([this.getFlights(flightsData)])
        .then((responses) => {
          return Promise.all(
            responses.map((response) => {
              return response
            }),
          )
        })
        .then((data) => {
          return data
        })
        .catch((err) => {
          console.log(err)
        })
      const flights = returns[0]
      this.setState({ flights: flights })
    }
  }

  getFlights = (data) => {
    return endpoints
      .getFlightInfoTable(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let flights = []
        if (data) {
          flights = data
        }
        return flights
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleInput = (event, search = true) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (this.state.q.length >= 1) {
          if (isMobile && !this.state.showOverlay) {
            // scroll to top to fix the input field in the overlay being out of view on iphone
            window.scrollTo(0, 0)
            this.setZIndexOfNotificationBanner(0)
          }
          this.setState({ showOverlay: true }, () => {
            if (search) this.search()
            if (isMobile) {
              this.props.handleOverlay(true)
              const elements = document.getElementsByClassName("site-header")
              const siteHeader = elements[0]
              if (siteHeader) {
                siteHeader.style.display = "none"
              }
            }
          })
        } else {
          if (!isMobile) {
            this.handleCloseOverlay(event)
          }
        }
      },
    )
  }

  handleDirectionChange = (direction, wasFocused) => {
    if (isMobile) {
      const input = document.getElementById("flight-search-hero-input")
      if (input && wasFocused) {
        input.focus()
        setTimeout(() => {
          this.setState({ mobileInputFocus: true })
        }, 20)
      }
    }
    this.setState({ direction: direction }, () => {
      this.search()
    })
  }

  handleCloseOverlay = () => {
    this.setState({ showOverlay: false, searchDate: this.state.startDate, q: "", flights: [] }, () => {
      if (isMobile) {
        const elements = document.getElementsByClassName("site-header")
        const siteHeader = elements[0]
        if (siteHeader) {
          siteHeader.style.display = null
          let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
          if (siteHeaderWrapper) {
            siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
          }
        }
        this.setZIndexOfNotificationBanner(null)
        this.scrollIntoView()
        this.props.handleOverlay(false)
      }
    })
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        let dateTime = DateTime.fromJSDate(dateInput)
        const startOfPrevDate = prevState.searchDate.startOf("day")
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = dateTime.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          // if the times are the same, meaning only the date was changed, set date to minDate
          const time = dateTime.toFormat("HH:mm")
          const prevTime = prevState.searchDate.toFormat("HH:mm")
          if (dateTime <= prevState.minDate || time === prevTime) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: dateTime, minTime: prevState.minDate }
        } else {
          // if the dates have changed, set time to 0
          if (startOfPrevDate.toMillis() !== startOfNewDate.toMillis()) dateTime = dateTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
          return { searchDate: dateTime, minTime: prevState.otherDaysMinTime }
        }
      },
      () => this.search(),
    )
  }

  handleDatepicker = () => {
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  handleOutsideClick = () => {
    if (!this.state.overInput) {
      this.setState({ showOverlay: false, datepickerOpen: false })
    }
  }

  handleInputFocus = () => {
    if (this.state.q.length > 0) {
      if (isMobile && !this.state.showOverlay) {
        // scroll to top to fix the input field in the overlay being out of view on iphone
        window.scrollTo(0, 0)
        this.setZIndexOfNotificationBanner(0)
      }
      this.setState({ showOverlay: true }, () => {
        if (isMobile) {
          this.scrollIntoView()
          this.props.handleOverlay(false)

          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = "none"
          }
        }
      })
    }
  }

  setZIndexOfNotificationBanner = (zindex) => {
    const notificationBanner = document.querySelector(".notification")
    if (notificationBanner) {
      const notificationVersion = notificationBanner.dataset.notificationVersion
      const notificationCookie = cookieHelper.getCookie(notificationVersion)
      if (notificationCookie !== "closed") {
        notificationBanner.style.zIndex = zindex
      }
    }
  }

  flightClickHandler = (e, flight) => {
    if (this.props.direction === "D") {
      this.props.setDataToState({ departureFlight: flight })
    } else {
      this.props.setDataToState({ arrivalFlight: flight })
    }
    if (isMobile) {
      this.handleCloseOverlay(e)
    }
  }

  editClickHandler = () => {
    if (this.props.direction === "D") {
      this.props.setDataToState({ departureFlight: undefined })
    } else {
      this.props.setDataToState({ arrivalFlight: undefined })
    }
    if (!isMobile) {
      this.setState({ showOverlay: false })
    }
  }

  scrollIntoView = () => {
    const parkingFollowFlight = document.querySelector(".parking-follow-flight")
    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight
    const elementPosition = parkingFollowFlight.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
    })
  }

  render() {
    if (this.props.chosenFlight) {
      return (
        <div className="chosen-flight">
          <h1 className="flight-info">{`${this.props.chosenFlight.Iata} - ${this.props.chosenFlight.DestinationName}`}</h1>
          <a className="edit" onClick={() => this.editClickHandler()}>
            {this.props.editLabel || "Rediger"}
          </a>
        </div>
      )
    }
    return (
      <div className="form__section form__section--light">
        <div className={`form__section__inner ${isMobile && this.state.showOverlay ? "is-active" : ""}`}>
          <div className="form__field form__field--text form__field--text-search form__field--text--no-label is-bound is-filled">
            <span className="form__valid"></span>
            <input
              className="form__item"
              id="flight-search-hero-input"
              autoComplete="off"
              autoCapitalize="none"
              name="q"
              type="text"
              placeholder={isMobile ? this.props.searchBoxPlaceholderMobile : this.props.searchBoxPlaceholder}
              value={this.state.q}
              onChange={(e) => this.handleInput(e)}
              onMouseEnter={() => this.setState({ overInput: true })}
              onMouseLeave={() => this.setState({ overInput: false })}
              onFocus={() => this.handleInputFocus()}
            />
            {!isMobile ? (
              <button
                className={`search-button ${this.state.showOverlay ? "active" : ""}`}
                onClick={() => (this.state.showOverlay ? this.handleCloseOverlay() : undefined)}
              >
                <div className={`search-icon`}></div>
              </button>
            ) : (
              ""
            )}
            {isMobile && this.state.showOverlay ? (
              <button onClick={(e) => this.handleCloseOverlay(e)}>
                <Svg iconName={"close"} fillColor={"#071143"} />
              </button>
            ) : (
              ""
            )}
          </div>
          <OutsideClickTrigger onOutsideClick={() => (isMobile ? undefined : this.handleOutsideClick())}>
            <SearchOverlay
              {...this.props}
              {...this.state}
              handleDirectionChange={this.handleDirectionChange}
              handleDateChange={this.handleDateChange}
              locale={this.props.locale === "da" ? da : enGB}
              handleDatepicker={this.handleDatepicker}
              closeDatepicker={this.closeDatepicker}
              flightClickHandler={this.flightClickHandler}
              showTime={true}
            />
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}
